import'./BulkOrder.scss';
import Home from './Home';

const BulkOrder = () =>{
    return <Home/>
}
export default BulkOrder